export const API_URL = process.env.REACT_APP_API_URL || '';

export const apiFetch = (path, options = {}) => {
  const headers = { ...(options.headers || {}) };
  if (process.env.NODE_ENV === 'development') {
    headers['ngrok-skip-browser-warning'] = 'true';
  }
  return fetch(`${API_URL}${path}`, { ...options, headers });
};

export const parseJsonSafe = async (res) => {
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (err) {
    return { message: text || 'Respuesta no válida del servidor' };
  }
};

export const handleUnauthorized = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('userEmail');
  window.location.href = '/login';
};

export const formatDate = (value) => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('es-ES');
};

export const daysUntil = (dateStr) => {
  if (!dateStr) return null;
  return Math.ceil((new Date(dateStr) - new Date()) / (1000 * 60 * 60 * 24));
};

// Formatea importes en euros (es-ES). Devuelve '-' si no hay valor numérico.
export const formatEur = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const num = Number(value);
  if (Number.isNaN(num)) return '-';
  return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(num);
};
